<template>
    <b-table v-if="payments.length > 0" :thead-class="head_class" :tbody-tr-class="rowClass"
             striped class="table-responsive-xl resolution_table" :items="payments" :fields="fields">

        <template v-slot:head(date)="data">
            Дата
        </template>

        <template v-slot:head(rest_count)="data">
            {{__t('SLOTS_COUNT')}}
        </template>

        <template v-slot:head(cost)="data">
            {{__t('COST')}}
        </template>

        <template v-slot:cell(cost)="data">
            <div >
                <div>
                    {{parseInt(data.item.cost) | toCurrency}}

                </div>


                <sup>
                    <span class="badge badge-success ml-2" v-if="data.item.status == 'regular' || data.item.status == 'pay'">
                        {{__t('PAY')}}
                    </span>
                </sup>
            </div>

        </template>
    </b-table>
</template>

<script>
export default {
    name: "bill_payments_table",
    props : {
        "payments" : {
            type : Array
        }
    },

    data() {
        return {
            fields: [
                {
                    key: 'date',
                    label: '',
                    class: 'text-left'
                },

                {
                    key: "rest_count",
                    label: '',
                    class: 'text-left'
                },

                {
                    key: 'cost',
                    label: '',
                    class: 'text-center'
                },
            ],
        }
    },
    methods : {
        rowClass(item) {
            if (!item) return;
            return item.class;
        },
    },
    computed : {

        head_class() {

        },
    }
}
</script>

<style scoped>

</style>
